import Axios from "axios"
import { unMask } from "remask"
import { Calendar, CompareNumbers } from "../utils/infoUtils"
import { Api, ApiAdimplencia } from "./api"

export const verifyProviderInfo = async (user_id) => {
    try {
        const { data } = await Api.get(`/users/searchbyid/${user_id}`)
        return data
    } catch (error) {
        console.log(error?.response)
        if (error && error.response && error.response.status === 401) {
            // toast.error("Seu token expirou, faça login novamente")
            // localClear();
            // navigate('/login');
            // window.location.reload()
            return { usuario_deslogado: true }
        }
        return { usuario_documento: null }
    }
}

export const verifyDatabaseService = async (user_id) => {
    try {
        const { data } = await Api.get(`/higienizacao/${user_id}`)
        return data.status
    } catch (error) {
        console.log(error?.response)
        return false
    }
}

export const getProfileInfo = async (associado_id) => {
    try {
        const { data } = await Api.get(`/associados/${associado_id}`)
        return data
    } catch (error) {
        console.log(error?.response)
        return {}
    }
}

export const getSMSInfo = async (documento) => {
    if (!documento) return { total_sms: "0", total_emails: "0" }

    try {
        const user_document = unMask(documento, '999.999.999-99', '99.999.999/9999-99')
        const { data } = await Api.get(`/historicosms/${user_document}`)

        return {
            total_sms: data ? String(data.sms) : "0",
            total_emails: data ? String(data.emails) : "0"
        }
    } catch {
        return { total_sms: "0", total_emails: "0" }
    }
}

export const getSMSDataGrafico = async (documento, max_meses, ano=new Date().getFullYear()) => {
    try {
        const user_document = unMask(documento, '999.999.999-99', '99.999.999/9999-99')

        const { data } = await Api.get(
            `/historicoComunicacoes/provider/${user_document}/${max_meses}/${ano}`
        )

        const { totais_comunicacao } = data
        const sorted = totais_comunicacao.sort(CompareNumbers)

        const email = sorted.map(e => Number(e.email))
        const sms = sorted.map(e => Number(e.sms))

        const mes = sorted.map(e => {
            const [m, a] = e.mes_ano.split("/")
            return { ano: a, mes: m }
        })

        return { email, sms, mes: Calendar(mes) }

    } catch {
        return { email: null, sms: null, mes: [] }
    }
}

export const getTransationInfo = async (ano=new Date().getFullYear()) => {
    try {
        const { data } = await Api.get(`historicodeposito/historicoMensal`, {params:{ano:ano}})

        const repasses = data.map(e => Number(e.valor))
        const meses = data.map(e => ({ ano: e.ano, mes: e.mes }))

        return {
            data: repasses.reverse(),
            meses: Calendar(meses).reverse()
        }
    } catch {
        return null
    }
}

export const getDashboardInfo = async (user_id) => {
    try {
        const { data } = await Api.get(`/cobranca/listaqtdpaga/${user_id}`)
        return data
    } catch {
        return null
    }
}

export const getBankInfo = async () => {
    try {
        const { data } = await Api.get(`/contadigital/buscar`)
        return data
    } catch {
        return null
    }
}

export const listAllProviders = async () => {
    try {
        const { data } = await Api.get("/users/listarProviders")

        return data.map(item => ({
            label: item.usuario_nome + (item.usuario_status ? "" : " (INATIVO)"),
            value: item.usuario_id,
            alt: `${item.usuario_nome} ${item.nome_fantasia}`
        }))

    } catch {
        return null
    }
}

export const listAllBanks = async () => {
    try {
        const { data } = await Axios.get(
            "https://brasilapi.com.br/api/banks/v1"
        )
        return data
    } catch {
        return null
    }
}

export const detalhesGestor = async () => {
    try {
        const { data } = await ApiAdimplencia.get(`/gestor/detalhes`)
        return data
    } catch {
        return false
    }
}

export const detalhesCredor = async (usuario_documento) => {
    try {
        const { data } = await ApiAdimplencia.get(
            `/credor/detalhe/${usuario_documento}`
        )
        // A API de recorrência responde no envelope { sucesso, mensagem, dados }.
        // Mantém compatibilidade com o formato antigo (objeto do credor direto).
        if (data && typeof data === 'object' && 'sucesso' in data && 'dados' in data) {
            return data.dados || false
        }
        return data
    } catch {
        return false
    }
}

export const listarRecebivelTipo = async (credor_id) => {
    if (!credor_id) return null

    try {
        const { data } = await ApiAdimplencia.get(
            `/recebivelTipo/listarTodos/${credor_id}`
        )

        return data.map(item => ({
            label: item.recebivel_tipo_descricao,
            value: item.recebivel_tipo_id
        }))

    } catch {
        return null
    }
}

export const getPCC_ID = async () => {
    try {
        const { data } = await Api.get(`/parametrizacaoproviders/buscaParametros`)
        return data ? data.selecionar : { pcc_id: null }
    } catch {
        return { pcc_id: null }
    }
}

export const getDiscountInfo = async (pcc_id) => {
    try {
        const { data } = await Api.get(`cobranca/cliente-valores-desconto/${pcc_id}`)
        return data
    } catch {
        return null
    }
}

export const getParcelamentoInfo = async () => {
    try {
        const { data } = await Api.get(`parametrosproviderparcelas/seleciona`)
        return data ? data.selectParametros : null
    } catch {
        return null
    }
}

export const getInfoJuros = async () => {
    try {
        const { data } = await Api.get(`parametrizacaoproviders/buscaJuros`)
        return data ? data.infoJuros : null
    } catch {
        return null
    }
}

export const getInfoMulta = async () => {
    try {
        const { data } = await Api.get(`parametrizacaoproviders/buscaMulta`)
        return data ? data.infoMulta : null
    } catch {
        return null
    }
}

export const getPlataformaPagamento = async (user_id) => {
    try {
        const { data } = await Api.get(
            `/credorPlataformaPagamento/consulta/${user_id}`
        )

        return data ? data[0].plataforma_nome : "ZOOP"

    } catch {
        return null
    }
}